import { useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { Bounce, toast } from "react-toastify";
import { environment } from "../../config/environment";

const EmployeeNotification = ({ onNotification }) => {
  const clientRef = useRef(null);
  const token = localStorage.getItem("bgc_token");
    const BASE_URL = environment.apiUrl; //TODO
//   const BASE_URL = "http://localhost:8086";

  useEffect(() => {
    if (!token) {
      return;
    }

    const client = new Client({
      webSocketFactory: () =>
        new SockJS(
          `${BASE_URL}/ws-employee?token=${encodeURIComponent(
            "Bearer " + token,
          )}`,
        ),

      reconnectDelay: 5000,

      debug: (msg) => {},

      onConnect: () => {
        client.subscribe("/user/employee/notifications", (message) => {
          if (!message?.body) {
            return;
          }

          try {
            const notification = JSON.parse(message.body);

            if (onNotification) {
              onNotification(notification);
            }

            window.dispatchEvent(
              new CustomEvent("employee-notification", {
                detail: notification,
              }),
            );

            toast.info(
              notification.message || "New employee notification received",
              {
                position: "top-right",
                autoClose: 5000,
                draggable: true,
                theme: "dark",
                transition: Bounce,
              },
            );
          } catch (err) {}
        });
      },

      onStompError: (frame) => {},

      onWebSocketClose: (event) => {},

      onWebSocketError: (event) => {},
    });

    clientRef.current = client;
    client.activate();

    return () => {
      if (clientRef.current) {
        clientRef.current.deactivate();
      }
    };
  }, [token, onNotification]);

  return null;
};

export default EmployeeNotification;
